import { Td, Text, Tr } from '@chakra-ui/react'
import { Skiptrace } from 'features/Skiptrace/domain/Skiptrace.domain'
import { Breakpoint } from 'presentation/components/Breakpoint'
import { EmailIcon } from 'presentation/components/Icons'
import { SkiptraceSubAccordionItem } from 'presentation/screens/SkiptraceScreen/components/SkiptraceResultsCard/components/SkiptraceSubAccordionItem'
import { DateValue, NewValue, SkiptraceTable } from 'presentation/screens/SkiptraceScreen/components/SkiptraceResultsCard/components/SkiptraceTable'

export type SkiptraceEmailsAccordionProps = {
  items: Skiptrace.PossibleEmailInfo[]
}

export const SkiptraceEmailsAccordion = (props: SkiptraceEmailsAccordionProps) => {
  const { items } = props
  const count = items.length
  const hasNew = items.some(v => v.isNew)
  return (
    <SkiptraceSubAccordionItem
      hasNew={hasNew}
      headerIcon={EmailIcon}
      headerLabel={`Possible Emails (${count})`}
      isEmpty={count === 0}
    >
      <SkiptraceTable>
        {items.map((item, i) => (
          <Tr key={i}>
            <Td w='80px' textAlign='center'>
              {item.isNew
                ? <NewValue />
                : item.updatedAt
                  ? <DateValue date={item.updatedAt} />
                  : null}
            </Td>

            <Breakpoint
              mobSm={(
                <Td>
                  <Text textStyle='bodyM' color='graystrong.200'>
                    Email
                  </Text>
                  <Text textStyle='bodyL' color='link.500'>
                    {item.email}
                  </Text>
                </Td>
              )}
              tabSm={(
                <>
                  <Td w='112px'>
                    <Text textStyle='bodyL' color='graystrong.200'>
                      Email
                    </Text>
                  </Td>
                  <Td>
                    <Text textStyle='bodyL' color='link.500'>
                      {item.email}
                    </Text>
                  </Td>
                </>
              )}
            />
          </Tr>
        ))}
      </SkiptraceTable>
    </SkiptraceSubAccordionItem>
  )
}
